import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=383ec218&scoped=true&"
import script from "./FileItem.vue?vue&type=script&lang=js&"
export * from "./FileItem.vue?vue&type=script&lang=js&"
import style0 from "./FileItem.vue?vue&type=style&index=0&id=383ec218&prod&lang=scss&scoped=true&"
import style1 from "./FileItem.vue?vue&type=style&index=1&id=383ec218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ec218",
  null
  
)

export default component.exports